import Vue from 'vue'
import AlertWindow from './AlertComponent.vue'

let alertInstance = null

const createAlertInstance = (propsData) => {
	const AlertConstructor = Vue.extend(AlertWindow)
	const instance = new AlertConstructor({ propsData })
	instance.$mount()
	document.body.appendChild(instance.$el)
	return instance
}

export const open = (options) => {
	if (alertInstance) {
		alertInstance.$destroy()
		alertInstance.$el.parentNode.removeChild(alertInstance.$el)
	}

	alertInstance = createAlertInstance({
		type: options.type || 'info',
		iconColor: options.iconColor || 'info',
		title: options.title || 'Alert',
		description: options.description,
		showIcon: options.showIcon,
		buttonConfirmPosition: options.buttonConfirmPosition || 'horizontal',
		buttonConfirmText: options.buttonConfirmText || 'Ya',
		buttonDeclineText: options.buttonDeclineText || 'Batal',
		buttonCloseText: options.buttonCloseText || 'Tutup',

		showBanner: options.showBanner || false,
		bannerStyle: options.bannerStyle || 'info',
		bannerMessage: options.bannerMessage || 'Message',

		showSellWarning: options.showSellWarning || false,

		withCheckbox: options.withCheckbox || false,
		checkboxMessage: options.checkboxMessage || 'I understand and agree to the terms and conditions',

		alertClass: options.alertClass || '',
		buttonConfirmClass: options.buttonConfirmClass || '',
		buttonDeclineClass: options.buttonDeclineClass || '',
		buttonCloseClass: options.buttonCloseClass || '',
	})

	if (options.onConfirm) {
		alertInstance.$on('confirm', options.onConfirm)
	}

	if (options.onDecline) {
		alertInstance.$on('decline', options.onDecline)
	}

	if (options.onClose) {
		alertInstance.$on('close', options.onClose)
	}
}

export const close = () => {
	if (alertInstance) {
		alertInstance.close()
		alertInstance = null
	}
}

export default {
	open,
	close,
}